import { Button, Grid } from '@material-ui/core';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import HomeIcon from '@material-ui/icons/HomeRounded';
import {
  getInfosBusiness,
  getInfosDashboard,
  getNotifications,
  getVitrineField,
  getContractToSign,
  getOpcoRecord,
} from '@webapps/business';
import {
  NotifProvider,
  useAuth,
  useQuery,
  useMutation, 
  useToast,
  useLocalStorage,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import CardNotification from 'components/Notification/cardNotification';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';

import Notifications from './Components/BusinessNotifications';
import AffiliateChart from './Components/Chart/AffiliateChart';
import ApplicationChart from './Components/Chart/ApplicationChart';
import ContractChart from './Components/Chart/ContractChart';
import PartnerChart from './Components/Chart/PartnerChart.js';
import TeamChart from './Components/Chart/TeamChart';
import ViewChart from './Components/Chart/ViewChart';
import IncompleteVitrine from './Components/IncompleteVitrine';
import Info from './Components/Info';
import Presentation from './Components/Presentation';
import Synthesis from './Components/Synthesis';
import ExternalInvite from './Components/Invite';

import theme from './theme';

const {
  colors: { background },
} = theme;

const DashboardBusiness = () => {
  const {
    cx,
    classes,
    css,
    theme: { fontSizes, spacing },
  } = useStyles(styles);

  const [incompleteVitrine, setIncompleteVitrine] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const page = useState(0);

  const { idUser, profile } = useAuth();

  const { data: vitrineField = {} } = useQuery(getVitrineField, {
    key: 'vitrineField',
    variables: { id: idUser },
  });

  const { data: allInfos = {}, isLoading } = useQuery(getInfosBusiness, {
    key: 'businessInfos',
    variables: { id: idUser },
  });

  const { data: opcoRecords = {}, refetch: refetchOpcoRecord } = useQuery(getOpcoRecord, {
    key: 'getOpcoRecord',
    variables: { id: idUser, from: 'business' },
  });

  const { addToast } = useToast();


  const {
    data: dashboardInfo = {},
    refetch,
    isLoading: isLoadingDashboard,
    isFetching: isFetchingDashboard,
  } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusiness',
    variables: { id: idUser },
  });

  const [invite, setInvite, removeInvite] = useLocalStorage('invite');

  useEffect(() => {
    if (
      allInfos?.address?.label &&
      allInfos?.website &&
      allInfos?.phone &&
      allInfos?.sector?.label &&
      allInfos?.size?.min &&
      allInfos?.size?.max &&
      allInfos?.headOffice?.city &&
      allInfos?.headOffice?.cityCode &&
      allInfos?.foundationDate
    ) {
      setIncompleteVitrine(false);
    } else {
      setIncompleteVitrine(true);
    }
  }, []);

  const {
    data: { content: notifs = [], totalElements } = {},
    refetch: refetchUnRead,
  } = useQuery(getNotifications, {
    key: ['notifsStudent', page + idUser],
    variables: {
      id: idUser,
      page: 0,
      size: 3,
      status: 'all',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    error,
    isLoading: isLoadingContract,
    isSuccess: isSuccessContract,
    mutateAsync: mutateGetContractToSign,
    data: contract = {},
  } = useMutation(getContractToSign);

  useEffect(() => {
    if (isSuccessContract) {
      setOpenModal(true);
    } else if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  } , [isSuccessContract]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'closeModal') {
        setOpenModal(false);
        refetchOpcoRecord();
        addToast({ status: 'success', message: 'Contrat signé avec succès !' });
      }
    };
  
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className={classes.container}>
      {profile === 'BUSINESS' &&
        idUser === dashboardInfo.profile?.id &&
        dashboardInfo.profile.completeRate !== 100 && (
          <div style={{ width: '100%' }}>
            <IncompleteVitrine
              open={incompleteVitrine}
              setOpen={setIncompleteVitrine}
            />
          </div>
        )}
          {opcoRecords?.length > 0 && opcoRecords.map((opcoRecord, index) => (
            <div>
              {opcoRecord?.contract && !opcoRecord?.contract?.businessSignAction && opcoRecord?.contract?.businessSignAction != "SIGNED" && (
              <Button
                  aria-label="close"
                  color="primary"
                  variant="contained"
                  disabled={isLoadingContract}
                  onClick={() => mutateGetContractToSign({ id: opcoRecord.id , from: 'business' })}
                >
                  Signer le contrat
                </Button>
              )}
            </div>
          ))}
        <Modal
          withStep={false}
          onCancel={() => setOpenModal(false)}
          open={openModal}
          height="90%"
          width={1000}
          title="Signer votre contrat"
        >
          <iframe src={contract.signature_link} width="100%" height="600px" />
        </Modal>
      {!isLoading && (
        <Grid
          container
          className={css({
            columnGap: 30,
            rowGap: 20,
            width: '100%',
            flexDirection: 'row',
          })}
        >
          {/* LEFT CARD
          --------------------------------------------------------------*/}
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            lg={3}
            xl={3}
            style={{
              background,
              borderRadius: 10,

              height: 'fit-content',
            }}
          >
            <Synthesis
              coverImage={dashboardInfo?.profile?.coverImageUrl}
              profileImage={dashboardInfo?.profile?.profileImageUrl}
              name={allInfos?.name}
              city={allInfos?.address?.city}
              cp={allInfos?.address?.cityCode}
              verified={dashboardInfo?.profile?.verified}
              sector={allInfos?.sector?.label}
              presentation={dashboardInfo?.profile?.presentation}
              slogan={vitrineField?.data?.slogan}
              location={allInfos?.address?.label}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm
            className={cx(
              css({
                height:
                  notifs?.length > 0
                    ? 'fit-content'
                    : 'calc(100vh - 75px - 68px)',
                '@media screen and (max-width: 768px)': {
                  height: 'fit-content',
                },
                background,
                borderRadius: 10,
              })
            )}
          >
            <Notifications notifs={notifs} totalElements={totalElements} />
          </Grid>

          {/* RIGHT CARD (STATS)
          --------------------------------------------------------------*/}
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Grid
              container
              className={css({
                rowGap: 30,
                overflowY: 'auto',
                height: 'calc(100vh - 75px - 25px)',
                '@media screen and (max-width: 768px)': {
                  height: 'fit-content',
                  overflow: 'visible',
                },
                '@media only screen and (max-width:1280px)': {
                  overflow: 'visible',
                  margin: '0',
                },
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              })}
            >
              <Grid
                container
                className={classes.grid}
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des visibilités
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <ViewChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.grid}
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des candidatures
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <ApplicationChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.grid}
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des affiliations
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <AffiliateChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.grid}
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des équipes
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <TeamChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.grid}
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des contrats
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <ContractChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                className={css({
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  background,
                  borderRadius: 10,
                  height: 'fit-content',
                  marginBottom: 25,
                  '@media screen and (max-width: 768px)': {
                    marginBottom: 0,
                  },
                })}
                direction="column"
              >
                <Grid item xs={12}>
                  <div
                    className={css({
                      color: '#152652',
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                      marginBottom: 20,
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.0px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '15px',
                      },
                    })}
                  >
                    Statistiques des partenaires
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    borderRadius: 10,
                  }}
                >
                  <PartnerChart
                    dashboardInfo={dashboardInfo}
                    isFetchingDashboard={isFetchingDashboard}
                    isLoadingDashboard={isLoadingDashboard}
                  />
                </Grid>
              </Grid>
            </Grid>
            {invite?.id && <ExternalInvite invite={invite} removeInvite={removeInvite} />}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

/* STYLES
  --------------------------------------------------------------*/
const styles = ({ fontSizes, spacing }) => ({
  container: {
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    fontSize: '13.5000px',
    fontWeight: 400,
    color: '#152652',
    lineHeight: '110%',
    '@media only screen and (max-width:768px)': {
      padding: '20px',
    },
  },
  maingridcontainer: {
    overflow: 'auto',
  },
  presentationContainer: {
    // marginTop: spacing(3),
  },
  dashInfosContainer: {
    marginTop: spacing(4),
    '@media only screen and (min-width:640px)': {
      marginTop: spacing(0),
    },
    '@media only screen and (max-width:1280px)': {
      marginTop: spacing(2.5),
      marginBottom: spacing(4),
    },
  },
  grid: {
    // NEED CONFIRMATION
    background,
    borderRadius: 10,
    height: 'fit-content',
  },
  paper: {
    padding: spacing(2),
  },
  dashInfosItem: {
    paddingBottom: spacing(5),
    paddingLeft: spacing(5),
    '@media only screen and (max-width:1200px)': {
      paddingBottom: spacing(2.5),
      paddingLeft: spacing(2),
    },
    '@media only screen and (max-width:640px)': {
      paddingLeft: spacing(0),
    },
  },
  mainstatscontainer: {
    height: 'calc(100vh - 75px - 50px)',
    display: 'flex',
    overflowY: 'auto',
    rowGap: 30,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '@media screen and (max-width: 768px)': {
      height: 'fit-content',
      outline: '1px solid red',
    },
    '@media only screen and (max-width:1280px)': {
      overflow: 'visible',
      margin: '0',
    },
  },
  statscards: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    border: '1px solid #E0E0E0',
    borderRadius: '10px',
    backgroundColor: '#F3F7FF',
  },
});

export default DashboardBusiness;
